import { render, staticRenderFns } from "./PayrollCalculation.vue?vue&type=template&id=fc4b7678&scoped=true"
import script from "./PayrollCalculation.vue?vue&type=script&lang=js"
export * from "./PayrollCalculation.vue?vue&type=script&lang=js"
import style0 from "./PayrollCalculation.vue?vue&type=style&index=0&id=fc4b7678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b7678",
  null
  
)

export default component.exports